define(['angular', '../../filters/text', 'jquery'], function (angular) {
    return angular.module('siteModels', ['textFilters']).factory('SiteModel', [
        '$filter',
        function ($filter) {
            var SiteModel = function (site) {
                if (typeof site == 'undefined' || !site) {
                    site = {};
                }

                site.delete = function (callback) {
                    var thisSite = this;

                    var request = thisSite.$delete();

                    request.then(function () {
                        if (typeof callback == 'function') {
                            callback();
                        }
                    });
                    return request;
                };

                site.save = function (callback) {
                    var thisSite = this;

                    var request = thisSite.$update();

                    request.then(function (data) {
                        thisSite.updateData(data);
                        if (typeof callback == 'function') {
                            callback();
                        }
                    });
                    return request;
                };

                site.updateData = function (data) {
                    var thisSite = this;

                    if (data) {
                        for (var key in data) {
                            this[key] = data[key];
                        }
                    }
                };

                site.disableAVMCampaigns = function () {
                    var thisSite = this;
                    var request = thisSite.$disableAVMCampaigns();
                };

                site.disableEmailCampaigns = function () {
                    var thisSite = this;
                    var request = thisSite.$disableEmailCampaigns();
                };

                site.disableSmsCampaigns = function () {
                    var thisSite = this;
                    var request = thisSite.$disableSmsCampaigns();
                };

                site.updateData(site);

                return site;
            };
            return SiteModel;
        },
    ]);
});
